<template>
  <div class="flex h-14 items-center justify-end border-b border-[#1c4848]/5 bg-[#fafbfc] px-4 sm:px-8">
    <RouterLink
      to="/profile"
      aria-label="Moj profil"
      class="flex min-h-11 min-w-0 items-center gap-3 rounded-xl px-2 transition-colors hover:bg-[#1c4848]/5"
    >
      <span class="max-w-[50vw] truncate text-sm font-semibold text-[#1c4848]">{{ auth.getName }}</span>
      <UserAvatar class="h-9 w-9 shrink-0 rounded-full text-xs" />
    </RouterLink>
  </div>
</template>

<script setup>
import UserAvatar from '@/components/app/dashboard/UserAvatar.vue';
import { useAuthStore } from '@/store/auth/index.js';

const auth = useAuthStore();
</script>
